<template>
    <div id="cookie-dialog" v-show="!isSet()">
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="cell small-12 medium-auto">
                    <slot>
                        <p>
                            We use cookies to help provide you with the best possible online experience.<br />
                            By using this site, you agree that we may store and access cookies on your device.
                        </p>
                    </slot>
                </div>
                <div class="cell small-12 medium-shrink">
                    <a class="button" @click.prevent="set"><i class="fas fa-check fa-fw"></i> GOT IT</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BaseCookie from './BaseCookie';
    export default {
        mixins: [BaseCookie],
    }
</script>